import { AxiosResponse } from 'axios';

import { IDetails } from '../../shared/ts/details';
import httpRequest from '../httpRequest';

const detailsAPI = {
  getPropertyDetailsById: async (id: string): Promise<IDetails> => {
    const { data } = (await httpRequest({
      url: `/property/details/${id}`,
      method: 'POST',
    })) as AxiosResponse;

    return data.data;
  },
};

export default detailsAPI;
